///ts-nocheck
import { VueConstructor } from "vue";
import config from "./Api-config";
import storage from "@/storage/storage";
class SignalGo {
    conn: WebSocket;
    id = null;
    connected = false;
    options = {
        url: config.SENTEC_PUBSUB_URL,
        autoRetry: true,
        //autoRetryInMs:1000*60*10,
        autoRetryInMs: 1000,
    };
    events = {};
    OnClose: any = null;
    OnError: any = null;
    OnConnected: any = null;
    log = {
        i(msg) {
            console.info("SignalGo", msg);
        },
        e(msg) {
            console.error("SignalGo", msg);
        },
        d(msg) {
            console.debug("SignalGo", msg);
        }
    };
    async Connect(opts) {
        const options = this.options;
        this.options = {
            ...options,
            ...opts
        };
        await this.doConnect();
    }
    async reConnect() {
        if (this.options.autoRetry) {
            setTimeout(async () => {
                if (this.conn.readyState == WebSocket.CLOSED) {
                    await this.doConnect();
                }
            }, this.options.autoRetryInMs);
        }
    }
    async disConnect() {
        if (this.connected) {
            this.conn.onclose = async (ev) => {
                this.log.e("On Close: " + ev);
                this.connected = false;
                if (this.OnClose) {
                    this.OnClose(ev);
                }
            };
            this.conn.close();
            this.connected = false;
        }
    }
    async doConnect() {
        if (!this.connected) {
            let tokenParam = "";
            const token = await storage.getItem(config.STORAGE_KEYS.TOKEN);
            if (token) {
                tokenParam = `?token=${token}`;
            }

            if (this.conn) {
                this.conn.onclose = null;
                this.conn.onerror = null;
                this.conn.onopen = null;
                this.conn.onmessage = null;
            }
            const conn = new WebSocket(`wss://${this.options.url + tokenParam}`);
            conn.onclose = async (ev) => {
                this.log.e("On Close: " + ev);
                this.connected = false;
                if (this.OnClose) {
                    this.OnClose(ev);
                }
                await this.reConnect();
            };

            conn.onmessage = (ev) => {
                const payload = JSON.parse(ev.data);
                if (payload.event) {
                    const callBack = this.events[payload.event];
                    if (callBack) {
                        callBack(payload);
                    }
                }
                this.log.i(ev);
            };
            conn.onerror = (ev) => {
                this.log.e("On Error: " + ev);
                this.connected = false;
                if (this.OnError) {
                    this.OnError(ev);
                }

                this.reConnect();
            };
            conn.onopen = (ev) => {
                this.log.i("Connected: " + ev);
                this.connected = true;
                if (this.OnConnected) {
                    this.OnConnected(ev);
                }
                Object.keys(this.events).forEach(key => {
                    this.registerEvent(key);
                });
            };
            this.conn = conn;
        }
    }
    checkAvailableEvents() {
        return Object.keys(this.events).length === 0
            && this.events.constructor === Object; // 👈 constructor check
    }
    registerEvent(key) {
        const payload = {
            "t": 2,
            "e": key
        };
        this.doSend(payload, "Error on event registration!");
    }
    unregisterEvent(key) {
        const payload = {
            "t": 3,
            "e": key
        };
        this.doSend(payload, "Error on event unregister!");
    }
    Unsubscribe(ev) {
        console.log("Unsubscribe");
        if (this.connected) {
            this.unregisterEvent(this.events[ev]);
        }
        delete this.events[ev];
        if (!this.checkAvailableEvents())
            this.disConnect();
        //TODO: unsubscribe to server
    }
    async Subscribe(ev, callback) {
        await this.Connect({});

        console.log("Subscribe");
        this.On(ev, callback);
    }
    On(ev, callBack) {
        this.events[ev] = callBack;
        if (this.connected) {
            this.registerEvent(ev);
        }
    }
    doSend(payload, err, force?) {
        if (!this.connected && !force) {
            console.error(err);
            return;
        }
        //let buff=this.str2ab(JSON.stringify(payload))
        this.conn.send(JSON.stringify(payload));
    }
    Send(ev, message) {
        const payload = {
            "t": 1,
            "m": message,
            "e": ev
        };
        this.doSend(payload, "Can't send message if connection is not established yet!");
    }

}
const signalGo = new SignalGo();
//signalGo.Connect({})
//export default signalGo


declare module "vue/types/vue" {
    interface Vue {
        $socket: {
            Unsubscribe(key),
            Subscribe(ev, callback)
            Connect()
        };
    }
}

export default function SocketPlugin(Vue: VueConstructor): void {
    Vue.prototype.$socket = signalGo;
}

